// src/language/layoutLanguage.js
const layoutLanguage = {
  en: {
    appTitle: 'Milk Billing',
    totalCustomersTitle: 'Total Customers',
    navHome: 'Home',
    navDashboard: 'Dashboard',
    navReport: 'Manage Bills',
    navSettings: 'More',
    logout: 'Logout',
  },
  mr: {
    appTitle: 'दूध बिलिंग',
    totalCustomersTitle: 'एकूण ग्राहक',
    navHome: 'होम',
    navDashboard: 'डॅशबोर्ड',
    navReport: 'बिल मॅनेजमेंट',
    navSettings: 'अधिक',
    logout: 'लॉगआउट',
  },
};

export default layoutLanguage;
